<template>
  <Walkthrough 
    roomName="El Garaje"
    roomKey="garage"
    :steps="steps"
    :backgroundImage="backgroundImage"
    language="spanish"
  />
</template>
<script>

export default {
  name: 'JailCell',
  props: ["roomName"],
  data() {
    return {
      backgroundImage: "https://d37bvzh6941o03.cloudfront.net/EscapeTheRoom/images/backgrounds/garage-1920x1280.jpg",
      steps: [
        "Mira a la derecha y luego inspecciona los estantes donde deberías encontrar un paño y un cubo.",
        "Mira a la izquierda e inspecciona la moto. Observa que tiene fugas, por lo que debes capturar parte del aceite para alimentar el generador.",
        "Mientras miras a la izquierda, usa el cubo en la motocicleta para llenarlo.",
        "Mira a la derecha y usa el cubo en el generador. Entonces, trata de usar el generador.",
        "Sin el cable de tracción, el generador no arranca. Usa la cuerda en el generador como un cable de tracción improvisado. El generador debe comenzar ahora y traer algo de energía a la habitación.",
        "Mira hacia adelante y usa el paño en la puerta del garaje para limpiar las ventanas. Te das cuenta de que estás en la calle HIDE. Esto debería ayudar con la caja de herramientas.",
        "Mira hacia abajo e inspecciona la caja de herramientas.",
        "Ingresa el código 3 - 5 - 2 - 1 (C E B A). La caja de herramientas debería abrirse y encontrarás algo de grasa.",
        "Mira hacia la derecha, inspecciona los estantes e inspecciona el reproductor de cintas. Deberías escuchar algo de código morse. ¡Este es el código para el interruptor!",
        "Mira a la izquierda, e inspecciona el interruptor de circuito.",

      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/walkthrough/es/garage.vue